import type {
  ChamberStateDto,
  EjectMainResponseDto,
  FireMainResponseDto,
} from '@schwrz/shared';
import { defineStore } from 'pinia';
import { ref } from 'vue';

import { api } from '../shared/api/client';

export const useWorkSessionsStore = defineStore('workSessions', () => {
  const state = ref<ChamberStateDto | null>(null);
  const loading = ref(false);

  async function refresh(): Promise<void> {
    loading.value = true;
    try {
      state.value = await api<ChamberStateDto>('/api/work-sessions/me');
    } finally {
      loading.value = false;
    }
  }

  async function chamber(taskId: string): Promise<void> {
    state.value = await api<ChamberStateDto>('/api/work-sessions/chamber', {
      method: 'POST',
      body: { taskId },
    });
  }

  async function fire(): Promise<void> {
    const res = await api<FireMainResponseDto>('/api/work-sessions/fire', { method: 'POST' });
    state.value = res.state;
  }

  async function eject(): Promise<void> {
    const res = await api<EjectMainResponseDto>('/api/work-sessions/eject', { method: 'POST' });
    state.value = res.state;
  }

  async function startInterrupt(label: string): Promise<void> {
    state.value = await api<ChamberStateDto>('/api/work-sessions/interrupt/start', {
      method: 'POST',
      body: { label },
    });
  }

  async function endInterrupt(): Promise<void> {
    state.value = await api<ChamberStateDto>('/api/work-sessions/interrupt/end', {
      method: 'POST',
    });
  }

  return {
    state,
    loading,
    refresh,
    chamber,
    fire,
    eject,
    startInterrupt,
    endInterrupt,
  };
});
